import './App.css';
import 'rsuite/dist/styles/rsuite-default.css';

import CustomForm from './EmailForm';

function App() {
  return (
    <div className="App">
      <h1 className="App-title" >OTP APPLICAION</h1>
      <CustomForm />
    </div>
  );
}

export default App;
